/**
 * AriaFloatGate — contractor-only Soren Home (always on).
 * Vendors: null. Auth loading: null.
 *
 * Inbox: NotificationCenter lived on AriaFloat. Soren opens alerts via
 * AriaChatPanel onOpenInbox → brief sheet (Quiet). Dedicated NotificationCenter
 * UI is not remounted here.
 */
import { useLocation } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import SorenHome from '../../features/soren/SorenHome'

const SOREN_SUPPRESSED_PATHS = /^\/(pricing|billing\/return)(\/|$)/

export default function AriaFloatGate() {
  const { user, loading } = useAuth()
  const { pathname } = useLocation()

  if (SOREN_SUPPRESSED_PATHS.test(pathname)) return null

  if (loading) return null

  if (user?.user_role === 'vendor' && user?.portal_session === 'vendor') return null
  if (user?.portal_session === 'vendor') return null

  return <SorenHome />
}
